import React, { useMemo } from 'react'
import MessageLog from 'components/pages/messageLog/MessageLog'
import { OUTBOUND_QUARANTINE_VIEW_CONFIG } from 'redux/features/mstore/mstoreSlice'
import { useViewConfig, UiState } from 'components/libs/messageLog/useViewConfig'

const OutboundQuarantine = () => {
  const { uiState } = useViewConfig(OUTBOUND_QUARANTINE_VIEW_CONFIG)

  return useMemo(
    () => (
      <>
        {uiState === UiState.READY && <MessageLog />}
        {uiState === UiState.INITIALIZING && null}
      </>
    ),
    [uiState]
  )
}

export default OutboundQuarantine
